import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors.ts'

export const SummaryCard = styled.div`
  border-radius: 13px;
  padding: 21px;
  border: 1px solid ${colors.gray300};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
`

export const SummaryCardText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const SummaryLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: ${colors.gray600};
`

export const SummaryValue = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.gray900};
  white-space: nowrap;
`

export const SummaryUnits = styled.span`
  font-size: 10px;
  color: ${colors.gray500};
`

export const SummaryCardTextSkeleton = styled(SummaryCardText)`
  gap: 6px;
`
